import { render } from "./dashboard_component.html?vue&type=template&id=454565d4&external"
import script from "./dashboard_component.js?vue&type=script&lang=js&external"
export * from "./dashboard_component.js?vue&type=script&lang=js&external"

import "./DashboardComponent.vue?vue&type=style&index=0&id=454565d4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__